import { SVGProps } from '@components/Icon/types';

export const Compensation = ({
  fill = '#000',
  size = 24,
  ...props
}: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.5, 2)">
      <path
        d="M16.7963 12.2638C16.7962 13.0199 16.1992 13.6423 15.4508 13.6424C14.7003 13.6424 14.1055 13.0198 14.1054 12.2638C14.1054 11.5078 14.7003 10.8843 15.4508 10.8843C16.1993 10.8844 16.7963 11.5077 16.7963 12.2638Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4737 3.42157C15.4737 3.79997 15.1674 4.10651 14.7895 4.10658C14.4115 4.10658 14.1054 3.80002 14.1054 3.42157V2.34499C14.1054 1.99119 14.0793 1.73411 14.0426 1.57804C14.023 1.49483 14.0066 1.44869 13.995 1.42465C13.9932 1.421 13.9915 1.41826 13.9902 1.41608C13.9844 1.41414 13.9754 1.41291 13.9636 1.41036C13.9256 1.40215 13.8615 1.39544 13.76 1.39702C13.5649 1.40009 13.2625 1.45438 12.8284 1.57233C11.555 1.91792 4.19928 4.01085 3.72236 4.1466L3.69381 4.16089C3.36895 4.28816 3.09174 4.41135 2.85552 4.52864C2.86629 4.52851 2.87706 4.52769 2.88787 4.52769H16.1121C17.6315 4.52793 19 5.84021 19 7.42494V17.2018C19 18.733 17.7797 20 16.2767 20H2.72326C1.22029 20 0 18.733 0 17.2018V7.49544C2.63614e-05 7.4362 0.00873494 7.36832 0.0133213 7.32585V7.0267C0.0150867 6.08222 0.11984 5.23194 0.638472 4.51435C1.15761 3.79741 1.99601 3.32475 3.24089 2.84136L3.24184 2.84041C3.25332 2.83596 3.28 2.82513 3.3094 2.81754L3.32652 2.81278C3.34135 2.80855 3.36368 2.8028 3.39218 2.79468L3.64243 2.72322L4.54637 2.46599C5.30024 2.25137 6.31924 1.96054 7.38096 1.65903C9.50342 1.05627 11.7988 0.407356 12.4802 0.222311L12.8256 0.132754C13.1587 0.0534677 13.4571 0.00468215 13.739 0.000324939C14.1118 -0.00539863 14.4986 0.0632224 14.8143 0.307103C15.1306 0.551572 15.2919 0.915839 15.3709 1.25316C15.4493 1.58772 15.4737 1.94248 15.4737 2.34499V3.42157ZM17.1445 6.40171C17.4451 6.69754 17.6317 7.07465 17.6317 7.42494V17.2018C17.6317 17.9855 17.0207 18.6043 16.2767 18.6043H2.72326C1.97755 18.6043 1.36829 17.9872 1.36829 17.2018V8.16711L1.38161 7.42398C1.40518 7.16367 1.54037 6.77635 1.79362 6.47507C2.07389 6.14058 2.44081 5.92357 2.88787 5.92344H16.1121C16.4619 5.92358 16.8441 6.106 17.1445 6.40171Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'compensation';
